import Logo from '@assets/icons/logo.svg?react';
import { t } from '@i18n';

export default function LoginHeader() {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '0.5rem',
      }}
    >
      <h1
        css={{
          fontSize: '3rem',
        }}
      >
        {t('title')}
      </h1>
      <Logo size={200} />
    </div>
  );
}
